import {defineAsyncComponent} from 'vue'

const CpesChilrensRouter = [
  {
    path: 'project',
    name: 'CpeProject',
    component: () => import('@/views/Cpes/CpeProject/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'bloggers',
    name: 'CpeBloggers',
    component: () => import('@/views/Cpes/CpeBloggers/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'directors',
    name: 'CpeDirectors',
    component: () => import('@/views/Cpes/CpeDirectors/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'cpeAccounts',
    name: 'CpeAccounts',
    component: () => import('@/views/Cpes/CpeAccounts/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'accountReport',
    name: 'CpeAccountReport',
    component: () => import('@/views/Cpes/CpeAccountReport/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'material',
    name: 'CpeMaterials',
    component: () => import('@/views/Cpes/CpeMaterials/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'works',
    name: 'CpeWorks',
    component: () => import('@/views/Cpes/CpeWorks/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  // CPE作品数据
  {
    path: 'cpe_works_data',
    name: 'CpeWorkDatas',
    component: () => import('@/views/Cpes/CpeWorkDatas/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'cpe_tags',
    name: 'CpeTags',
    component: () => import('@/views/Cpes/CpeTags/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'cpe_tags_type',
    name: 'CpeTagTypes',
    component: () => import('@/views/Cpes/CpeTags/CpeTagTypes.vue'),
    meta: {
      key: 'cpe'
    },
  },
  {
    path: 'credentials',
    name: 'CpeCredentials',
    component: () => import('@/views/Cpes/CpeCredentials/Index.vue'),
    meta: {
      key: 'cpe'
    },
  },
]

const CpesRouter = [
  {
    path: 'cpe',
    name: 'cpe',
    redirect: 'cpeProjects',
    meta: {
      key: 'cpe'
    },
    children: CpesChilrensRouter
  }
]

export {CpesRouter}
